import React from "react";

import { User } from "@hl/shared-features/lib/features/auth/User";
import { maskAddress } from "@hl/shared-features/lib/utils/content";
import { Box, Flex, GroupProps, Loader } from "@mantine/core";

import { usePublicUserProfileQuery } from "~features/MintPage/queries.graphql.generated";

import { NftContractStandard } from "../../apollo/graphql.generated";

const TokenOwnedBy = ({
  ownerAddress,
  ownerEns,
  standard,
  ...rest
}: {
  ownerAddress?: string;
  ownerEns?: string;
  standard?: NftContractStandard;
} & GroupProps) => {
  const { data, loading } = usePublicUserProfileQuery({
    variables: {
      slug: ownerAddress || "",
    },
    skip: !ownerAddress || standard === NftContractStandard.ERC1155,
    notifyOnNetworkStatusChange: true,
  });
  if (standard === NftContractStandard.ERC1155) {
    return null;
  }
  const account = data?.getPublicAccountSettings;

  return (
    <Flex {...rest} align="center">
      {loading ? (
        <Box lh={0}>
          <Loader size="xs" />
        </Box>
      ) : account ? (
        <User
          avatarUrl={account.displayAvatar}
          displayName={account.displayName || ownerEns}
          walletAddresses={account.walletAddresses}
          verified={!!account.verified}
          imported={!!account.imported}
          enableLink
          avatarSize={18}
          leadingText="Owned by"
        />
      ) : (
        ownerEns || maskAddress(ownerAddress, 4, 4)
      )}
    </Flex>
  );
};
export default TokenOwnedBy;
